<template>
	<BannerShortcutForm
		:is-loading="isLoading"
		:banner-type="bannerType"
		@onSubmit="handleSubmit"
	/>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import BannerShortcutForm from '@/components/BannerShortcutForm.vue';

import { BANNER_TYPE } from '../enums/banners';
import { ROUTE_NAME } from '../enums/route';
import { scrollToTop } from '../assets/js/helpers';

export default {
	name: 'BannerShortcutCreate',

	components: {
		BannerShortcutForm,
	},

	props: {
		bannerType: {
			type: String,
			default: BANNER_TYPE.shortcut,
		},
		context: {
			type: String,
			default: '',
		},
	},

	computed: {
		...mapState('banners', {
			create: 'create',
		}),

		isLoading() {
			return this.create.isLoading;
		},
	},

	methods: {
		...mapActions({
			showToast: 'toast/showToast',
			createBannerGroup: 'banners/createBannerGroup',
		}),

		async handleSubmit(data) {
			try {
				await this.createBannerGroup(data);

				const routeName = ROUTE_NAME.BANNER_SHORTCUT_LIST;

				this.$router.push({ name: routeName });
			} catch {
				scrollToTop();
			}
		},
	},
};
</script>
